import axios from "@/libs/api.request";

export const getBroadCastListForNew = (param) => {
  return axios.request({
    url: '/api/api_v2.2.5/broad/query/all.json',
    method:'get',
    params:param,
  })
}

export const getBroadCastListForNoPage = (param) => {
  return axios.request({
    url: '/api/api_v2.2.5/broad/query/queryAllOfNoPage.json',
    method:'post',
    data:param,
  })
}

export const findDeptAndEmp = () => {
  return axios.request({
    url: 'api/20221024/infs/getDepetAndEmp.json',
    method:'post',
  })
}
/******
 * type :  文字、音乐、、
 * play_type :  即使广播、定时广播
 */
// 获取广播模板
export const getBroadcastTemplate=({type,playType})=>{

  return axios.request({
    url: '/api/20210204/infs/getBroadcastTemplate.json',
    method: 'get',
    params:{
      type: type,
      playType:playType
    }
  })
}

export const updateBroadCastCascade = (form,broadLog) => {
  const data = {...form}
  return axios.request({
    url: '/api/api_v2.2.5/broad/update.json',
    method: 'post',
    data,
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}
export const addBroadCastCascade = (form, broadLog)=>{
  const data = {...form}
  return axios.request({
    url: '/api/api_v2.2.5/broad/add.json',
    method: 'post',
    data,
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

/*提示音*/
export const getTone=()=>{
    return axios.request({
      url: '/api/20180628/infs/getAudioList.json',
      method: 'get'
    })
}

/*接入号*/
export const getPstn = ({task_id, task_type}) => {
  const data = {
    task_id,
    task_type
  }
  return axios.request({
    url: '/api/20180628/infs/getAccessnumList.json',
    method: 'post',
    data
  })
}

/*提示音、音乐库*/
export const getToneOfDept=(deptId,isAdmin,language,all,isShowKey)=>{
  const data = {
    deptId,isAdmin,language,all,isShowKey
  }
  return axios.request({
    url: '/api/20210928/infs/getMusicStoreList.json',
    data,
    method: 'post'
  })
}
/*播放列表*/
export const getPlayQueue=(deptId,isAdmin)=>{
  return axios.request({
    url: '/api/20180628/infs/getPlayList.json',
    params:{
      deptId:deptId,
      isAdmin:isAdmin
    },
    method:'get'
  })
}

/*获取系统默认的节假日*/
export const getSysHolidays = (type) => {
  return axios.request({
    url: '/api/20210114/infs/getHoliday.json',
    params:{
      type:type
    },
    method:'get'
  })
}


/*** 离线任务相关接口 ***/


//添加
export const addOfflineBroadCast = (form)=>{
  const data = {...form}

  return axios.request({
   url: '/api/offlineBroad/add',
    method: 'post',
    data
  })
}

//编辑离线任务
export const updateOfflineBroadCast = (form) => {
  const data = {...form}

  return axios.request({
    url: '/api/offlineBroad/update',
    method: 'post',
    data
  })
}
/*获取所有的离线任务*/
export const getAllOfflineTasksForNew = (param) => {
  const data = {...param}
  return axios.request({
    url: '/api/offlineBroad/findByPage',
    data,
    method:'post'
  })
}
/*获取离线任务下发详情*/
export const getOfflineTaskExtenDetailsByIdForNew = (param) => {
  const data = {...param}
  return axios.request({
    url: '/api/offlineBroad/findDetails',
    data,
    method:'post'
  })
}
  /*获取分机下的已下发任务*/
  export const getOfflineTasksByExten = (exten) => {
    return axios.request({
      url: '/api/offlineBroad/findByExten',
     params:{
      exten:exten
     },
     method:'get'
   })
  }

    /*同步分机下的任务*/
  export const deviceTaskSync = (extens) => {
    return axios.request({
      url: '/api/offlineBroad/syncByExten',
     params:{
      extens:extens
     },
     method:'get'
   })
  }

//删除离线任务

export const deleteOfflineBroadCast = ({bId,bName}, broadLog)=>{
  const data = {
    bId,
    bName
  }
  return axios.request({
    url: '/api/offlineBroad/delete',
    method: 'post',
    data
  })
}

/*重新下发/重新删除*/
export const retry = (operation,bId,exten) => {
  return axios.request({
    url: '/api/offlineBroad/retry',
    params:{
      operation:operation,
      bId:bId,
      exten:exten
    },
    method:'get'
  })
}

//强制删除

export const forceDeleteOfflineTask = (bId,exten)=>{

  return axios.request({
    url: '/api/offlineBroad/forceDelete',
    method: 'GET',
    params:{
      bId:bId,
      exten:exten
     }
  })
}


/*设置任务状态*/
export const setBroad = ({id, b_enable}) => {
  const data = {
    id,
    b_enable
  }
  return axios.request({
    url: '/api/20210618/infs/setBroad.json',
    method: 'post',
    data
  })
}
/***
 *
 * 检测broadcastTask是否存在中间状态（未开始，开始，进行中）则列表刷新
 *
 * */
export const broadtaskExistMiddleStatus = () => {
  return axios.request({
    url: '/api/offlineBroad/broad/checkStatus',
    method: 'get'
  })
}


/***
 *
 * 检测ctloffline是否存在中间状态（未开始，开始，进行中）则列表刷新
 * bId为空 则查询全部
 *
 * */
export const ctlofflineExistMiddleStatus = (bId) => {
  return axios.request({
    url: '/api/offlineBroad/checkStatus',
    params: {
      bId: bId
    },
    method: 'get'
  })
}
/**
 * 获取单个广播详情
 * @param id
 * @returns {*}
 */
export const getOneBroadDetail = (id) => {
  return axios.request({
    url: '/api/api_v2.2.5/broad/query/detail.json',
    params: {
      id: id
    },
    method: 'get'
  })
}
/**
 * 查询广播方案
 * @param params
 * @returns {*}
 */
export const getAllActionPlanForPage = (params) => {
  return axios.request({
    url: 'system-service/api-v2.2.6/broad/scheme/query',
    data: params,
    method: 'post'
  })
}

/**
 * 查询广播所有文字、语音的定时广播
 * @param params
 * @returns {*}
 */
export const getAllBroadForPlan = (params) => {
  return axios.request({
    url: 'system-service/api-v2.2.6/broad/getAllBroadForPlan',
    data: params,
    method: 'post'
  })
}
/**
 * 查询广播方案详情
 * @param params
 * @returns {*}
 */
export const getAllPlanDetail = (params) => {
  return axios.request({
    url: 'system-service/api-v2.2.6/broad/scheme/detail',
    data: params,
    method: 'post'
  })
}
/**
 * 添加广播方案
 * @param params
 * @returns {*}
 */
export const addBroadPlan= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/scheme/add',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}
/**
 * 添加广播方案
 * @param params
 * @returns {*}
 */
export const updateBroadPlan= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/scheme/update',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}
/**
 * 删除广播方案
 * @param params
 * @returns {*}
 */
export const deleteBroadPlan= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/scheme/delete',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}
/**
 * 修改广播方案状态
 * @param params
 * @returns {*}
 */
export const setPlanState= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/setPlanState',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}
/**
 * 获取启用的方案
 * @param params
 * @returns {*}
 */
export const getEnablePlan= () => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/getEnablePlan',
    method: 'post',
  })
}
/**
 * 获取所有未启用的方案
 * @param params
 * @returns {*}
 */
export const getAllBroadPlan= () => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/getAllBroadPlan',
    method: 'post',
  })
}
/**
 * 获取方案切换的数据
 * @param params
 * @returns {*}
 */
export const getAllChangeData= () => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/getAllChangeData',
    method: 'post',
  })
}

/**
 * 启用广播时搜索当前广播是否被方案使用
 * @param params
 * @returns {*}
 */
export const checkBroadIsUse= (params) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/checkBroadIsUse',
    data:params,
    method: 'post',
  })
}

/**
 * 批量监测广播是否被方案使用
 * @param params
 * @returns {*}
 */
 export const checkBroadIdsIsUse= (params) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/checkBroadIdsIsUse',
    data:params,
    method: 'post',
  })
}

/**
 * 添加方案切换的数据
 * @param params
 * @returns {*}
 */
export const addChangeData= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/addChangeData',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}

/**
 * 编辑方案切换的数据
 * @param params
 * @returns {*}
 */
export const updateChangeData= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/updateChangeData',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}

/**
 * 删除方案切换的数据
 * @param params
 * @returns {*}
 */
export const deleteChangeData= (params,log) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/deleteChangeData',
    data:params,
    method: 'post',
    headers:{
      'Menu_id':log.menu_id,
      'Sysuser_id':log.sysuser_id,
      'Journal_title':encodeURIComponent(log.journal_title)
    }
  })
}
/**
 * 获取部分广播数据，用于方案
 * @param params
 * @returns {*}
 */
export const getPartDataBroadById= (params) => {
  return axios.request({
    url:'system-service/api-v2.2.6/broad/getPartDataBroadById',
    data:params,
    method: 'post',
  })
}

/**
 * 判断是否有外部广播
 * @returns {*}
 */
export const hasOutSideBroad = () =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/broad/exits',
    method:'get',
  })
}

/**
 * 获取系统的级联架构
 * @returns {*}
 */
 export const systemCascadeTree = () =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/tree',
    method:'get',
  })
}

/**
 * 获取分区的级联架构
 * @returns {*}
 */
 export const deptCascadeTree = (appKey) =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/tree/dept',
    params:{
      'appKey':appKey
    },
    method:'get',
  })
}

/**
 * 获取分机的级联架构
 * @returns {*}
 */
 export const EmployeeCascadeTree = (appKey,deptId,state,showField) =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/dept/extens',
    params:{
      'appKey':appKey,
      'deptId':deptId,
      'state':state,
      'showField':showField
    },
    method:'get',
  })
}

/**
 * 搜索分机
 * @returns {*}
 */
 export const searchExten = (exten,appKey,grade,array) =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/exten/search',
    params:{
      'exten':exten,
      'appKey':appKey,
      'grade':grade,
      'array':array
    },
    method:'get',
  })
}

/**
 * 根据分机号获取全部父级id
 * @returns {*}
 */
 export const searchId = (models) =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/exten/depts',
    data:models,
    method:'post',
  })
}

/**
 * 级联删除广播
 * @returns {*}
 */
 export const cascadeDeleteBroadCast = (params,broadLog) =>{
  return axios.request({
    url:'/api/api_v2.2.5/broad/delete.json',
    data:params,
    method:'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

/**
 * 级联批量删除广播
 * @returns {*}
 */
 export const cascadeBatchDelete = (params) =>{
  return axios.request({
    url:'/api/api_v2.2.5/broad/batchDelete.json',
    data:params,
    method:'post',
  })
}

/*采播分机*/
export const extensSearch =(deptId,isAdmin,exten)=>{
  return axios.request({
    url: 'system-service/api-v2.0/grade/broad/extensSearch',
    params:{
      deptId:deptId,
      isAdmin:isAdmin,
      exten:exten
    },
    method: 'get'
  })
}

//获取广播记录
export const broadLogs = (params={})=>{
  return axios.request({
    url : '/system-service/api-v2.3.0/BroadCastLog/query',
    params,
    method:'get'
  })
}

export const broadLogDetail = (params={}) => {
  return axios.request({
    url : '/system-service/api-v2.3.0/BroadCastLog/query/detail',
    params,
    method:'get'
  })
}


/**
 * 查询紧急广播
 * @returns {*}
 */
export const queryEmergencyBroad = () => {
  return axios.request({
    url:'/api/broad/emergency/find',
    method:'get'
  })
}

/**
 * 保存紧急广播配置
 */
export const saveEmergencyBroad = (form) => {
  const data = {...form}
  return axios.request({
    url:'/api/broad/emergency/save',
    method:'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/broadcast.js